import React from "react";

export interface Arrow {
  id: string | number;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

interface ArrowLayerProps {
  zoom: number;
  arrows: Arrow[];
  stroke?: string;
  strokeWidth?: number;
  panX?: number;
  panY?: number;
}

export default function ArrowLayer({
  zoom,
  arrows,
  stroke = "#64748b",
  strokeWidth = 2,
  panX = 0,
  panY = 0,
}: ArrowLayerProps) {
  return (
    <svg className="absolute inset-0 w-full h-full pointer-events-none">
      <g
        style={{
          transform: `translate(${panX}px, ${panY}px) scale(${zoom})`,
          transformOrigin: "top left",
        }}
      >
        {arrows.map((a) => (
          <g key={a.id}>
            <line
              x1={a.x1}
              y1={a.y1}
              x2={a.x2}
              y2={a.y2}
              stroke={stroke}
              strokeWidth={strokeWidth}
              markerEnd="url(#arrow)"
            />
          </g>
        ))}
      </g>
      <defs>
        <marker
          id="arrow"
          markerWidth="10"
          markerHeight="10"
          refX="6"
          refY="3"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,6 L9,3 z" fill={stroke} />
        </marker>
      </defs>
    </svg>
  );
}
